import { render, staticRenderFns } from "./CrosswordStyleSelectModal.vue?vue&type=template&id=0512e47b&scoped=true"
import script from "./CrosswordStyleSelectModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CrosswordStyleSelectModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CrosswordStyleSelectModal.vue?vue&type=style&index=0&id=0512e47b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0512e47b",
  null
  
)

export default component.exports